import { Link } from "react-router-dom";
import { Instagram, MapPin, MessageCircle } from "lucide-react";
import { Monogram } from "./Logo";
import { PROFILES } from "../lib/profiles";
import { SITE, waLink } from "../lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-[#D4AF37]/20 bg-[#080E21] overflow-hidden">
    <div className="mx-auto max-w-[1360px] px-6 lg:px-10 pt-20 pb-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4">
            <Monogram className="w-14 h-14" id="ft-gold" />
            <div>
              <p className="font-cinzel text-xl tracking-[0.12em] text-gold-soft">GRUPO AUGUSTINIS</p>
              <p className="text-[10px] tracking-[0.42em] text-[#C0C9DC] mt-1">DIREITO E SOLUÇÕES</p>
            </div>
          </div>
          <p className="mt-6 max-w-sm text-sm text-[#AEB9D0] leading-relaxed">{SITE.tagline}</p>
        </div>
        <div className="lg:col-span-4">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Seu caso</p>
          <ul className="space-y-3">
            {PROFILES.map((p) => (
              <li key={p.slug}>
                <Link to={`/perfil/${p.slug}`} data-testid={`footer-profile-${p.slug}`} className="text-sm text-[#C0C9DC] hover:text-[#E6C687] transition-colors duration-300">{p.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Contato</p>
          <ul className="space-y-4 text-sm text-[#C0C9DC]">
            <li><a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-[#E6C687] transition-colors duration-300"><MessageCircle className="w-4 h-4 text-[#D4AF37]" />{SITE.whatsappDisplay}</a></li>
            <li><a href={SITE.instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-[#E6C687] transition-colors duration-300"><Instagram className="w-4 h-4 text-[#D4AF37]" />{SITE.instagram}</a></li>
            <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#D4AF37]" />{SITE.city}</li>
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="mt-20 font-cinzel text-[15vw] lg:text-[11.5vw] leading-none text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.22)] select-none whitespace-nowrap">AUGUSTINIS</p>
      <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#8F9BB8]">
        <p>© {new Date().getFullYear()} {SITE.legal}. Todos os direitos reservados.</p>
        <p>As informações deste site têm caráter informativo e não substituem a análise individual do caso.</p>
      </div>
    </div>
  </footer>
);
